import { render } from "./RecommendedList.vue?vue&type=template&id=364b7a0f&scoped=true"
import script from "./RecommendedList.vue?vue&type=script&lang=js"
export * from "./RecommendedList.vue?vue&type=script&lang=js"

import "./RecommendedList.vue?vue&type=style&index=0&id=364b7a0f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364b7a0f"]])

export default __exports__